import React from 'react';
import { twMerge } from 'tailwind-merge';
import { MarkdownOrNode } from '../../../utils/markdownOrNode';

const BodyText = ({ children, className = '', light, full, markless }) => {
  return (
    <div
      className={twMerge(
        'w-full text-sm lg:text-base text-left font-epilogue font-light leading-normal',
        full ? '' : 'lg:max-w-[600px]',
        light ? 'text-new-light-75' : 'text-new-dark-75',
        '[&_p]:mb-5 last:[&_*]:mb-0',
        '[&_a]:underline [&_a]:font-semibold lg:[&_a]:font-light [&_a:hover]:font-semibold',
        className,
      )}
    >
      {markless ? children : <MarkdownOrNode mark>{children}</MarkdownOrNode>}
    </div>
  );
};

export default BodyText;
